<div class="page-root">
  <div class="title">
    @if (mobile) {
      <app-icon-button (click)="back()" colorVariant="secondary-dark" icon="arrow_back" size="small"/>
    }
    <div class="typo-h1">{{ "booking.selectAppointment.title" | transloco }}</div>
  </div>

  <div class="labeled-text">
    <div class="label">
      <mat-icon>home</mat-icon>
      <div class="body-text-bold">{{ "booking.label.practise" | transloco }}</div>
    </div>

    {{ memoryService.locationDetailDto?.name }}
  </div>

  <div class="labeled-text">
    <div class="label">
      <mat-icon>event</mat-icon>
      <div class="body-text-bold">{{ "booking.label.appointment" | transloco }}</div>
    </div>

    {{ this.appointmentSelectionService.timeSlotDto?.startTime | customDate:'HH:mm' }} - {{ this.appointmentSelectionService.timeSlotDto?.endTime | customDate:'HH:mm' }}
    <br>
    {{ this.appointmentSelectionService.timeSlotDto?.startTime | customDate:'cccc, dd.MM.yyyy' }}
  </div>

  <div class="labeled-text">
    <div class="label">
      <mat-icon>accessibility_new</mat-icon>
      <div class="body-text-bold">{{ "booking.label.category" | transloco }}</div>
    </div>

    {{ categoryName | localizedText }}
  </div>

  @if(categoryPrice){
    <div class="labeled-text">
      <div class="label">
        <mat-icon>attach_money</mat-icon>
        <div class="body-text-bold">{{ "form.label.price" | transloco }}</div>
      </div>

      {{ categoryPrice }}
    </div>
  }

  <div class="labeled-text">
    <div class="label">
      @if (employee?.imageUrl) {
        <img [src]="employee?.imageUrl" class="avatar">
      } @else {
        <mat-icon>person</mat-icon>
      }

      <div class="body-text-bold">{{ "booking.label.employee" | transloco }}</div>
    </div>

    {{ employee?.firstName }} {{ employee?.lastName }}
  </div>

  <div class="actions">
    @if (mobile) {
      <app-text-button (click)="navigateToBooking()" [text]="'booking.selectAppointment.button' | transloco" colorVariant="primary" trailingIcon="keyboard_arrow_right" type="rounded"/>
    } @else {
      <app-text-button (click)="back()" [text]="'button.change' | transloco" colorVariant="tertiary" leadingIcon="edit" type="rounded"/>
    }
  </div>
</div>
